<template>
  <div id="reset" class="centered-form">
    <AppHeader />
    <div class="card container" v-if="submitted">
      <h1>{{ $t('auth.reset_request_succes_title') }}</h1>
      <p>{{ $t('auth.reset_request_succes_message') }}</p>
      <router-link to="/login">{{ $t('auth.log_in_button') }}</router-link>
    </div>
    <div class="card container" v-else>
      <h1>{{ $t('auth.reset_title') }}</h1>
      <div v-if="errorMessage" class="alert alert-danger fade show" role="alert">
        {{ errorMessage }}
      </div>

      <form @submit.prevent>
        <div class="form-group">
          <label for="email1">{{ $t('auth.email_label') }}</label>
          <input
            class="form-control"
            v-model.trim="resetForm.email"
            type="email"
            :placeholder="$t('auth.email_place_holder')"
            id="email1"
          />
        </div>
      </form>

      <div class="extras">
        <div>
          <button @click="reset" class="btn btn-primary">
            {{ $t('auth.reset_request_button') }}
          </button>
        </div>
        <div>
          <router-link to="/login">{{ $t('auth.log_in_button') }}</router-link>
            <button
            class="btn btn-outline-primary btn-sm dropdown-toggle"
            type="button"
            id="locale"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ locale | fullLocale }}
          </button>
          <ul class="dropdown-menu" aria-labelledby="locale">
            <li><a class="dropdown-item" href="#" v-on:click="setLocale('en')">{{ 'en' | fullLocale}}</a></li>
            <li><a class="dropdown-item" href="#" v-on:click="setLocale('fr')">{{ 'fr' | fullLocale}}</a></li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppHeader from '@/components/ui/AppHeader.vue';
import AuthenticationService from '@/service/AuthenticationService';
import I18nMixin from '@/utils/I18nMixin';

export default {
  mixins: [I18nMixin],
  components: {
    AppHeader,
  },
  data() {
    return {
      resetForm: {
        email: '',
      },
      submitted: false,
      errorMessage: null,
    };
  },
  methods: {
    reset() {
      // FIXME: do the opposite (i.e store dispatch only)
      const authenticationService = new AuthenticationService(this.$store);
      authenticationService
        .resetPassword(this.resetForm.email, this.$i18n.locale)
        .then(() => {
          this.submitted = true;
        })
        .catch((error) => {
          console.log({ error });
          switch (error.code) {
            case 'auth/wrong-password':
              this.errorMessage = this.$t('auth.errors.wrong_password');
              break;
            case 'auth/user-not-found':
              this.errorMessage = this.$t('auth.errors.user_not_found');
              break;
            case 'auth/invalid-email':
              this.errorMessage = this.$t('auth.errors.invalid_email');
              break;
            default:
              this.errorMessage = this.$t('auth.errors.unknown_error');
              console.log(error);
              break;
          }
        });
    },
  },
};
</script>


<style scoped>
#locale {
  margin-top: 20px;
  font-size: .8rem;
}
</style>
